// https://www.notion.so/landr/16ca40de80e942f3a8f25f9e944dd70a?v=c3689c08477f42418abeced2159777fd

var EventIds = /*#__PURE__*/function (EventIds) {
  EventIds[EventIds["PricingPagePartialLoadDataFail"] = 22001] = "PricingPagePartialLoadDataFail";
  EventIds[EventIds["SelectedMasteringPackIsUndefined"] = 22002] = "SelectedMasteringPackIsUndefined";
  EventIds[EventIds["SessionsPricingFetchError"] = 22004] = "SessionsPricingFetchError";
  EventIds[EventIds["UserSubscriptionMetadataLoadDataFail"] = 22005] = "UserSubscriptionMetadataLoadDataFail";
  EventIds[EventIds["BundleCatalogLoadDataFail"] = 22006] = "BundleCatalogLoadDataFail";
  EventIds[EventIds["UserMetadataFail"] = 22007] = "UserMetadataFail";
  EventIds[EventIds["CatalogSaleFail"] = 22008] = "CatalogSaleFail";
  EventIds[EventIds["PricingRedirectionError"] = 22009] = "PricingRedirectionError";
  EventIds[EventIds["PluginsCatalogFetchDataFail"] = 22010] = "PluginsCatalogFetchDataFail";
  EventIds[EventIds["PluginNotFoundInCatalog"] = 22011] = "PluginNotFoundInCatalog";
  EventIds[EventIds["EligibleForFreeTrialFetchError"] = 22012] = "EligibleForFreeTrialFetchError";
  EventIds[EventIds["ErrorFetchingPopularCourses"] = 22013] = "ErrorFetchingPopularCourses";
  EventIds[EventIds["ErrorFetchingAvailableDeals"] = 22014] = "ErrorFetchingAvailableDeals";
  return EventIds;
}({});

export { EventIds };
